import React from "react";
import { Mutation } from "react-apollo";
import { Typography, Button, Input, Paper } from "@material-ui/core";

import { QUERY_AI } from "../../../../../graphql/query";

export default class TestQuery extends React.Component {
  state = {
    queryText: "",
    showResult: {
      responseText: "",
      input: "",
      detected: {
        sheetName: "",
        data: [{ category: "", headline: "", trainingPhase: [] }]
      }
    }
  };

  handleChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  render() {
    const detectedData =
      this.state.showResult.detected &&
      this.state.showResult.responseText &&
      this.state.showResult.detected.data.filter(
        i =>
          i.result.replace(/\s+/g, "") ===
          this.state.showResult.responseText.replace(/\s+/g, "")
      )[0];
    return (
      <Mutation mutation={QUERY_AI}>
        {queryAi => {
          return (
            <Paper
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "24px"
              }}
            >
              <Typography variant="title">Test Query</Typography>

              <div>
                <Input
                  name="queryText"
                  placeholder="Search Query"
                  value={this.state.queryText}
                  onChange={this.handleChange}
                />
                <Button
                  color="secondary"
                  onClick={async () => {
                    const {
                      data: { queryAi: result }
                    } = await queryAi({
                      variables: { text: this.state.queryText }
                    });
                    this.setState({ showResult: result });
                  }}
                >
                  Query
                </Button>
              </div>
              <div
                style={{
                  marginTop: "20px",
                  paddingTop: "20px",
                  borderTop: "#555 1px solid"
                }}
              >
                <Typography variant="subheading">Query Result</Typography>
                <div>
                  <Typography
                    variant="body2"
                    style={{ display: "inline-block" }}
                  >
                    Input:{" "}
                  </Typography>
                  <Typography
                    variant="body1"
                    style={{ marginLeft: "5px", display: "inline-block" }}
                  >
                    {this.state.showResult.input || ""}
                  </Typography>
                </div>
                <div>
                  <Typography
                    variant="body2"
                    style={{ display: "inline-block" }}
                  >
                    Response:{" "}
                  </Typography>
                  {this.state.showResult.responseText
                    .split("<br>")
                    .map((res, z) => (
                      <Typography
                        variant="body1"
                        key={z}
                        style={{ marginLeft: "5px" }}
                      >
                        {res || ""}
                      </Typography>
                    ))}
                </div>
                {this.state.showResult.detected && (
                  <React.Fragment>
                    <div>
                      <Typography
                        variant="body2"
                        style={{ display: "inline-block" }}
                      >
                        SheetName:{" "}
                      </Typography>
                      <Typography
                        variant="body1"
                        style={{ marginLeft: "5px", display: "inline-block" }}
                      >
                        {this.state.showResult.detected.sheetName || ""}
                      </Typography>
                    </div>
                    <div>
                      <Typography
                        variant="body2"
                        style={{ display: "inline-block" }}
                      >
                        Intent:{" "}
                      </Typography>
                      <Typography
                        variant="body1"
                        style={{ marginLeft: "5px", display: "inline-block" }}
                      >
                        {(detectedData && detectedData.headline) || ""}
                      </Typography>
                    </div>
                    <div>
                      <Typography
                        variant="body2"
                        style={{ display: "inline-block" }}
                      >
                        Training Phrase:
                      </Typography>
                      <Typography
                        variant="body1"
                        style={{ marginLeft: "5px", display: "inline-block" }}
                      >
                        {(detectedData &&
                          detectedData.trainingPhase.join(", ")) ||
                          ""}
                      </Typography>
                    </div>
                  </React.Fragment>
                )}
              </div>
            </Paper>
          );
        }}
      </Mutation>
    );
  }
}



// WEBPACK FOOTER //
// ./src/main/content/project/ai/components/TestQuery.js